import "./Contact.module.css";
import Navigation from "@/reusable_sections/Header";
import Quote from "./sections/Quote";
import Remodel from "./sections/Remodel";
import Expectations from "./sections/Expectations";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Navigation />
      
      <Quote />
      <Remodel />
      <Expectations />
      <Footer />
    </div>;
}